<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_v"><img alt="Kindling the Moon: An Arcadia Bell Novel, by Jenn Bennett. Pocket." height="100%" src="images/title.jpg"/></a></p><a id="page_v">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?3269cf9c